import _ from 'lodash';
import { createSelector } from 'reselect';

const getDraft = state => _.get(state, 'campaignDuplicateModal.draft');
const getOrganizations = state => _.get(state, 'campaignDuplicateModal.organizations');
const getOwnOrg = state => _.get(state, 'campaignDuplicateModal.ownOrganization');
export const getClientMapping = createSelector(
    getDraft,
    draft => {
        let clientMapping = {};
        if (draft) {
            _.each(draft.clients, c => (clientMapping[c.organization] = c));
        }

        return clientMapping;
    }
);
export const getChildOrganizations = createSelector(
    getOrganizations,
    getOwnOrg,
    (organizations, ownOrganization) => {
        if (ownOrganization) {
            return _.omit(organizations, [ownOrganization.id]);
        }
        if (!organizations) {
            return {};
        }
        if (!ownOrganization || !ownOrganization.id) {
            return organizations;
        }
        return _.omit(organizations, [ownOrganization.id]);
    }
);

export const getAdvertisers = createSelector(
    getChildOrganizations,
    childOrganizations => {
        return _(childOrganizations)
            .filter(x => x)
            .filter(org => org.attr.client_type === 'advertiser')
            .map(org => ({
                label: org.attr.name,
                revenueModel: org.attr.revenueModel,
                agencyMarginRate: org.attr.agencyMarginRate,
                deprecated: org.attr.deprecated,
                value: org.id,
            }))
            .sortBy('label')
            .value();
    }
);

export const getSalesReps = createSelector(
    getChildOrganizations,
    childOrganizations => {
        return _(childOrganizations)
            .filter(x => x)
            .filter(org => org.attr.client_type === 'sales_rep')
            .map(org => ({
                label: org.attr.name,
                value: org.id,
                deprecated: org.attr.deprecated,
            }))
            .sortBy('label')
            .value();
    }
);

export const getPartners = createSelector(
    getChildOrganizations,
    childOrganizations => {
        return _(childOrganizations)
            .filter(x => x)
            .filter(org => org.attr.client_type === 'partner')
            .map(org => ({
                label: org.attr.name,
                value: org.id,
                deprecated: org.attr.deprecated,
            }))
            .sortBy('label')
            .value();
    }
);
